import dataServices from "@/services/dataServices";
import { error } from "@refinitiv-ui/elements/notification";

export default {
    onKeyup (event) {
      if (event.target.id === 'username' && event.key === 'Enter') {
        this.$refs.password.focus()
      }
      else if (event.target.id === 'password' && event.key === 'Enter') {
        this.login()
      }
    },
    redirectUserLogin() {
      dataServices.go2safe()
    },
    fetchResponse(){
      let uri = window.location.href.split('/');
      if(uri.length>4 && !this.loggedIn){
        dataServices.fetchJWT(uri[4],uri[5]).then((data) => {
          // console.log(data["data"])
          if(data["data"]["d"]){
            this.jwt = data["data"]["d"]["jwt"]
            localStorage.setItem('jwt', this.jwt)
            this.extract(this.jwt)
            window.location.href = uri[0]+"//"+uri[2]
          }
        })
      }
    },
    extract(jwt) {
      let parts = jwt.split('.')
      let bodyEnc = parts[1]
      let base64 = bodyEnc.replace(/-/g, '+').replace(/_/g, '/')
      if (!base64) {
        return
      }
      let bodyStr = atob(base64)
      let body
      try {
          body = JSON.parse(bodyStr)
      }
      catch (e) {
        body = {}
      }
      let exp = body.exp
      // console.log(exp)
      let user = body.usr
      console.log(user)

      if (!this.isExpired(exp)) {
        this.currentUser = user
        this.loggedIn = true
        this.dismissNotification()
      }
      else {
        this.currentUser = null
        this.loggedIn = false
        localStorage.removeItem('jwt')
        this.redirectUserLogin()
      }
    },
    isExpired(exp) {
        if (!exp) return true;
        let now = Date.now();
        return now >= exp * 1000;
    },
    login () {
      const regEx = RegExp(/[a-zA-Z0-9]+\.[a-zA-Z0-9]+@(?:lseg|refinitiv)\.com$/gm)
      if (regEx.test(this.$refs.username.value) && this.$refs.password.value === 'isituseful?') {
        this.loggedIn = true
        localStorage.setItem(`${this.appName}.lastLoggedIn`, new Date().getTime())
        this.dismissNotification()
        // Usage tracking
      }
      else {
        error('Invalid username or password')
      }
    },
    logout() {
        this.currentUser = null
        this.loggedIn = false
        this.loggedOut = true
        localStorage.removeItem('jwt')
    },
        checkLogin () {
      const jwt = localStorage.getItem('jwt')
      console.log(jwt)
      if (jwt == null) {
        let uri = window.location.href.split('/');
        if(uri.length>4){
          this.fetchResponse()
        }else{
          this.redirectUserLogin()
        }
      }else{
        this.extract(jwt)
      }
    },
    getUserId(){
      const jwt = localStorage.getItem('jwt');
      let parts = jwt.split('.')
      let bodyEnc = parts[1]
      let base64 = bodyEnc.replace(/-/g, '+').replace(/_/g, '/')
      if (!base64) {
        return
      }
      let bodyStr = atob(base64)
      let body
      try {
          body = JSON.parse(bodyStr)
      }
      catch (e) {
        body = {}
      }
      let user = body.usr
      return user.trid
    },
    sendRequestEmail() {
      const email = "DSPSalesToolSupport@lseg.com";
      const subject = "Request for access to DSP Support Tool";
      const userId = this.getUserId()
      const emailBody = encodeURI(`Hi Team,\n\nMy employee ID is ${userId}. Could you please grant me an access to the DSP Support Tool?\n\nThank you!`);
      document.location = "mailto:"+email+"?subject="+subject+"&body="+emailBody;
    },
}